import { API_URLS } from "../../constants";
import apiClient from "../../utils/interceptor";

const getAuthToken = () => {
  return localStorage.getItem("auth_token");
};

export const getScansByYardsAndDate = async (payload) => {
  const token = getAuthToken();

  try {
    const response = await apiClient.post(
      API_URLS.SCAN.GET_SCANS_BY_YARDS_AND_DATE,
      payload, 
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching scans by yards and date:", error);
    throw error;
  }
};

export const getScansByYardsAndDays = async (payload) => {
  const token = getAuthToken();

  try {
    const response = await apiClient.post(
      API_URLS.SCAN.GET_SCANS_BY_YARDS_AND_DAYS,
      payload, 
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching scans by yards and date:", error);
    throw error;
  }
};

export const deleteScan = async (scanId) => {
  const token = getAuthToken();
  try {
    const response = await apiClient.delete(
      `${API_URLS.SCAN.DELETE_SCAN}/${scanId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting scan:", error);
    throw error;
  }
};

export const getSessionsByGateIdsAndDate = async (payload) => {
  const token = getAuthToken();

  try {
    const response = await apiClient.post(
      API_URLS.SESSION.GET_SESSIONS_BY_GATE_IDS_AND_DATE,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching sessions by gate ids and date:", error);
    throw error;
  }
};

export const getSessionSkusDetails = async (sessionId) => {
    try {
        const response = await apiClient.get(
            `${API_URLS.SESSION.GET_SESSION_SKUS_DETAILS}/${sessionId}`
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching session SKU details:", error);
        throw error;
    }
};